export default "__VITE_ASSET__NrYATKR0__"